module.exports = __webpack_public_path__ + "media/images/checked-6ab7b8b5da87322950bb3ff3fdb39e18.svg";